export const matchesDayRange = (daysWithoutPurchase, range, includeUnlocated = true) => {
  if (range === "unlocated") return daysWithoutPurchase == null;
  const minimum = Number(range);
  if (![14, 21, 30, 45].includes(minimum) || !range) return true;
  if (daysWithoutPurchase == null) return includeUnlocated;
  return Number.isFinite(daysWithoutPurchase) && daysWithoutPurchase >= minimum;
};

export const compareByInactivityAscending = (a = {}, b = {}) => {
  const daysA = Number.isFinite(a.daysWithoutPurchase) ? a.daysWithoutPurchase : Number.POSITIVE_INFINITY;
  const daysB = Number.isFinite(b.daysWithoutPurchase) ? b.daysWithoutPurchase : Number.POSITIVE_INFINITY;
  return daysA - daysB || String(a.customerName || "").localeCompare(String(b.customerName || ""), "pt-BR");
};
